//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS ,GameStatus , BetType  } from './enum';

export default {
    name: 'OnlineCountBadge',
    props: {
        count: [Number, String],
        isAbsolute: {
            type: Boolean,
            default: false
        }
    }
};
